import { PureComponent } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import styled from 'styled-components';
import { Tooltip } from 'react-tippy';
import { isMobile } from 'utils/domUtils';
import DropdownList from 'root/components/DropdownList/DropdownList';
import { selectPalette } from 'root/selectors';
import SvgIcon from '../SvgIcon';
import SVG_ICONS from '~/assets/icons/icons';

import './SearchBox.scss';

export const SEARCH_BOX_MODES = {
  BUTTON: 1,
  EXPANDED: 2,
};

const Wrapper = styled.div.attrs((props) => ({
  className: `search-bar search-form search-box bc-window-border active search-box-mode-${props.mode}`,
}))`
  border-width: 1px;
  border-style: solid;
  background-color: ${(props) => props.palette.window};

  &:focus-within {
    border-color: ${(props) => props.palette.link};

    .change-fill-on-focus path {
      fill: ${(props) => props.palette.link};
    }
  }
`;

export class SearchBox extends PureComponent {
  static defaultProps = {
    inputPlaceholder: '',
    searchHandler: null,
    mode: SEARCH_BOX_MODES.EXPANDED,
    value: '',
  };

  componentDidMount() {
    this.setFocusOnSearchInput();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mode !== this.props.mode) {
      this.setFocusOnSearchInput();
    }
    if (this.searchInput && prevProps.value?.length && !this.props.value?.length) {
      this.searchInput.value = '';
    }
  }

  onSearchClick = () => {
    if (this.props.searchHandler) {
      this.props.searchHandler();
      if (isMobile() && this.searchInput) {
        this.searchInput.blur();
      }
    }
  };

  onSearchInputChange = () => {
    if (this.props.termChangeHandler && this.searchInput) {
      this.props.termChangeHandler(this.searchInput.value);
    }
  };

  onSearchInputKeyUp = (e) => {
    if (e.which === 13 && this.props.searchHandler) {
      this.props.searchHandler();
      if (isMobile() && this.searchInput) {
        this.searchInput.blur();
      }
    }

    if (e.which === 27 && this.props.onEscClickHandler) {
      this.props.onEscClickHandler();
      e.stopPropagation();
    }
  };

  setFocusOnSearchInput = () => {
    if (this.props.mode === SEARCH_BOX_MODES.EXPANDED) {
      if (this.searchInput) {
        this.searchInput.focus();
      }
    }
  };

  searchInput;

  render() {
    const { props } = this;

    const isExpanded = props.mode === SEARCH_BOX_MODES.EXPANDED;
    const mode = isExpanded ? SEARCH_BOX_MODES.EXPANDED : SEARCH_BOX_MODES.BUTTON;

    return isExpanded ? (
      <Wrapper mode={mode} palette={props.palette}>
        <div className="form">
          {props.searchOptions && (
            <DropdownList
              className="search-types"
              dataTest="search-types"
              items={props.searchOptions}
              selectedItem={props.selectedSearchOption}
              onChange={(value) => {
                if (props.searchOptionHandler) {
                  props.searchOptionHandler(value);
                }
                if (this.searchInput) {
                  this.searchInput.focus();
                }
              }}
            />
          )}
          <input
            type="search"
            data-test="search-input"
            className={cx('text-field search-input outline-0', {
              'with-clear-btn': props.showClearButton,
            })}
            placeholder={props.inputPlaceholder}
            onChange={this.onSearchInputChange}
            onKeyUp={this.onSearchInputKeyUp}
            style={{
              height: '20px',
            }} /* TODO: Temporary! */
            ref={(elm) => (this.searchInput = elm)}
            value={props.value}
          />

          <div
            data-test="do-clear"
            className={cx('pointer absolute top-0 h-100 flex items-center justify-center clear-btn', { show: props.showClearButton })}
            style={{ right: 28, top: 6 }}
            onClick={props.onClearClickHandler}
          >
            {props.showClearButton ? (
              <Tooltip title={props.clearBtnTip} arrow animation="scale" delay={250} duration={200} hideDelay={0} size="small" className="tip">
                <SvgIcon path={SVG_ICONS.CANCEL} size="xl" colorName="window-border" className="change-fill-on-focus" />
              </Tooltip>
            ) : null}
          </div>

          <div data-test="do-search" className="do-search pointer absolute top-0 h-100 flex items-center justify-center" onClick={this.onSearchClick}>
            <SvgIcon path={SVG_ICONS.SEARCH} size="sm" colorName="window-border" className="change-fill-on-focus" />
          </div>
        </div>

        {props.children}
      </Wrapper>
    ) : (
      <div data-test="do-search" className="do-search pointer h-100 flex items-center justify-center" onClick={this.onSearchClick}>
        <SvgIcon path={SVG_ICONS.SEARCH} size="sm" colorName="link" />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  palette: selectPalette(state),
});

export default connect(mapStateToProps)(SearchBox);
